import React from 'react';
import PropTypes from 'prop-types';

import { GIC_BALANCE } from '@ratehub/inv-common';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import GICsAccountPropType from '../definitions/GICsAccountPropType';
import HeadingPropTypes from '../definitions/HeadingPropTypes';
import getGICRatesProps from '../functions/getGICRatesProps';
import HeadingBlock from './HeadingBlock';
import ProductCardWithBigNumberBox from './ProductCardWithBigNumberBox';


function ProductSingleGICs({
    heading,
    gicsAccount,
    monthlyBalance = GIC_BALANCE[1],     // $5_000
    ...otherProps
}) {
    return (
        // If gicsAccount is nullish (usually because the product is deprecated), don't render anything.
        // This is to ensure legacy pages with deprecated products don't prevent exporter from running.
        <If condition={gicsAccount}>
            <div {...otherProps}>
                <If condition={heading}>
                    <HeadingBlock
                        {...heading}
                    />
                </If>

                <ProductCardWithBigNumberBox product={getGICRatesProps(gicsAccount, monthlyBalance)} />
            </div>
        </If>

    );
}

ProductSingleGICs.propTypes = {
    heading: HeadingPropTypes,
    gicsAccount: GICsAccountPropType,
    monthlyBalance: PropTypes.number,
};


ProductSingleGICs.blockKey = 'rh/product-single-gics';
ProductSingleGICs.hasHeading = true;
ProductSingleGICs.requiresLayoutRow = true;
ProductSingleGICs.supportedPageTypes = [ PAGE_TEMPLATES.gics ];


export default ProductSingleGICs;
